<template>
  <div class="order-detail" data-automation="OrderDetail">
    <!-- 详情 -->
    <div v-if="isShowDetail" class="order-detail-content">
      <!-- 头部信息 -->
      <order-detail-info
        :order-info="orderInfo"
        :is-expansion="isExpansion"
        @over-order="overOrder"
        @change-expansion="changeExpansion"
      ></order-detail-info>

      <!-- 对话框 -->
      <order-detail-chat
        :order-info="orderInfo"
        :msg-list="msgList"
        :is-expansion="isExpansion"
        :is-user="isUser"
        @change-expansion="changeExpansion"
        @refresh="getWorkOrderDetails"
        @over-order="overOrder"
      ></order-detail-chat>
    </div>

    <!-- 缺省页 -->
    <div v-else class="order-detail-nodata">
      <default-graph type="2" :text="$t('HT.orderDetail.nodate')"></default-graph>
    </div>
  </div>
</template>

<script>
import defaultGraph from '@c/defaultGraph/defaultGraph';
import orderDetailInfo from './orderDetailInfo';
import orderDetailChat from './orderDetailChat';

export default {
  name: 'OrderDetail',
  components: {
    defaultGraph,
    orderDetailInfo,
    orderDetailChat
  },
  props: {
    isUser: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isGeting: false,
      isExpansion: false, // 展开全部
      orderInfo: null, // 基础信息 要选中才有
      userData: {}, // 用户信息
      // 聊天记录
      msgList: [],
      getWorkOrderDetailsTimer: null
    };
  },
  created() {
    this.userData = this.$store.state.login.userData;
  },
  computed: {
    isShowDetail() {
      return this.orderInfo && !this.isGeting;
    }
  },
  methods: {
    changeExpansion() {
      this.isExpansion = !this.isExpansion;
    },
    // 右侧点击工单
    clickOrder(data) {
      this.orderInfo = data;
      this.isExpansion = false;
      this.getWorkOrderDetails();
    },
    // 获取工单详情
    getWorkOrderDetails(isTimer) {
      clearTimeout(this.getWorkOrderDetailsTimer);
      this.getWorkOrderDetailsTimer = null;
      if (!isTimer) {
        this.$uxLoading.show();
        this.isGeting = true;
      }
      const orderInfo = this.orderInfo;
      const { id } = this.userData;

      const params = {
        orderId: orderInfo.id,
        userId: id
      };
      this.$api.workOrder
        .getWorkOrderDetails(params)
        .then((res) => {
          if (res.code == 10000) {
            const data = res.data || [];
            const msgList = data.reverse();
            // this.msgList = [];
            // this.$nextTick(() => {
            this.msgList = msgList;
            // });

            const hasImgUploading = msgList.some((msg) => {
              return String(msg.img_status) === '0';
            });

            // 有未完成的图片继续刷新
            if (hasImgUploading) {
              this.getWorkOrderDetailsTimer = setTimeout(() => {
                this.getWorkOrderDetails(true);
                clearTimeout(this.getWorkOrderDetailsTimer);
                this.getWorkOrderDetailsTimer = null;
              }, 1000);
            }

            if (Number(orderInfo.oldMsgStatus) !== 1) {
              this.readMessage(orderInfo.id);
            }
          }
        })
        .catch((err) => {
          const { sub_msg } = err.response.data || {};
          this.$uxMessage.error(sub_msg);
        })
        .finally(() => {
          this.$uxLoading.hide();
          this.isGeting = false;
        });
    },
    // 已读
    readMessage(order_id) {
      const { id } = this.userData;
      const params = {
        order_id,
        user_id: id
      };
      this.$api.workOrder.readMessage(params, { hideMsg: true });
    },
    // 工单结束
    overOrder() {
      const title = this.$t('HT.orderDetail.overOrder');
      const content = this.$t('HT.orderDetail.overOrder.centent');
      this.$uxModal.show({
        title,
        content,
        confirm: () => {
          this.$uxLoading.show();
          const params = {
            order_id: this.orderInfo.id
          };
          this.$api.workOrder
            .workOrderOff(params)
            .then((res) => {
              if (res.code == 10000) {
                this.orderInfo.order_status = 3;
                this.$uxMessage.success(this.$t('HT.addApi.operateSuccess'));
                this.$emit('over-order');
                this.$uxModal.hide();
                this.$uxLoading.hide();
              }
            })
            .catch((err) => {
              const { sub_msg } = err.response.data || {};
              this.$uxMessage.error(sub_msg);
              this.$uxLoading.hide();
            });
          this.$emit('over-order');
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.order-detail {
  overflow: hidden;
  position: relative;
  background: $color-bg-disable;

  .order-detail-content {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;
    box-sizing: border-box;
    flex-direction: column;
    padding: 24px 32px 16px;
  }

  .order-detail-nodata {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .order-detail-chat {
    min-height: 514px;
  }
}
</style>
